module.exports = __webpack_public_path__ + "img/Gemeindezeltlager(2).186a197f.jpg";